module.exports = __webpack_public_path__ + "img/pic.fafd9d43.svg";